<template>
	<div class="upload">
		<div class="list" :class="textAlign">
			<div class="item" v-for="(item, index) in list" :key="index">
				<img :src="item.url" alt="" class="previewImg" />
				<div class="imgMask">
					<div>
						<el-button
							size="mini"
							circle
							icon="el-icon-zoom-in"
							@click="preview(index)"
						></el-button>
						<el-button
							size="mini"
							circle
							icon="el-icon-delete"
							@click="delImg(index)"
						></el-button>
					</div>
					<div v-if="list.length > 1">
						<el-button
							size="mini"
							icon="el-icon-d-arrow-left"
							plain
							circle
							@click="prev(index)"
						></el-button>
						<el-button
							size="mini"
							icon="el-icon-d-arrow-right"
							plain
							circle
							@click="next(index)"
						></el-button>
					</div>
				</div>
			</div>
			<div class="item" v-show="list.length < n || !n" @click="chooseImg">
				<input
					type="file"
					class="fileInput"
					ref="fileInput"
					@change="fileChange($event.target.files)"
					accept="image/*"
					multiple
				/>
				<i v-if="!loading" class="el-icon-plus"></i>
				<i v-else class="el-icon-loading"></i>
			</div>
		</div>
	</div>
</template>
<script>
// import axios from 'axios'
// import { qiniuToken } from '@/api/common'
import { getOssMsg } from '@/api/oss'
import OSS from 'ali-oss'
export default {
	data() {
		return {
			list: [],
			loading: false
		}
	},
	props: {
		//集合名称
		flieName: { type: String, default: () => '' },
		//文本格式
		textAlign: { type: String, default: () => '' },
		//文本格式
		folder: { type: String, default: () => 'sundry' },
		//允许单次选择的数量
		n: { type: Number, default: () => 1 },
		//默认原始数据
		oldImgs: { type: Array, default: () => [] },
		// 上传时候额外返回的值
		item: {
			type: Object,
			default: () => {
				return {}
			}
		},
		// 是否隐藏操作按钮
		isHide: { type: Boolean, default: () => false }
	},
	created() {
		const newValue = this.oldImgs
		console.log(newValue)
		this.defaultImgs(newValue)
	},
	watch: {
		oldImgs(newValue) {
			this.defaultImgs(newValue)
		}
	},
	methods: {
		fileChange(file) {
			console.log(file)
			let num = this.list.length
			if (file) {
				for (let index = 0; index < file.length; index++) {
					num++
					if (num <= this.n) {
						this.uploadFile(file[index])
					}
				}
			}
		},

		random_string(len) {
			len = len || 32
			var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
			var maxPos = chars.length
			var pwd = ''
			for (let i = 0; i < len; i++) {
				pwd += chars.charAt(Math.floor(Math.random() * maxPos))
			}
			return pwd
		},

		uploadFile(file) {
			console.log(file.size)
			if (file.size < 102400) {
				const fileName = file.name
				const suffix = fileName
					.substring(fileName.lastIndexOf('.') + 1)
					.toLowerCase()
				if (
					suffix === 'bmp' ||
					suffix === 'jpg' ||
					suffix === 'jpeg' ||
					suffix === 'png' ||
					suffix === 'gif'
				) {
					this.loading = true
					getOssMsg().then(res => {
						console.log(123);
						const config = {
							accessKeyId: res.access_key_id,
							accessKeySecret: res.access_key_secret,
							stsToken: res.security_token,
							bucket: res.bucket,
							region: res.region
						}
						return new Promise(() => {
							const fileName = `supply/${this.folder}/${this.random_string(
								10
							)}.jpg`

							let client = new OSS(config)
							client
								.multipartUpload(fileName, file, {
									callback: {
										url: res.callback_url,
										host: res.callback_host,
										/* eslint no-template-curly-in-string: [0] */
										body: 'bucket=${bucket}&object=${object}&var1=${x:var1}',
										contentType: 'application/x-www-form-urlencoded',
										customValue: {
											var1: 'value1',
											var2: 'value2'
										}
									}
								})
								.then(results => {
									console.log(results)
									this.loading = false
									let uData = {}
									uData.url = `https://${res.cdn_domain}/${results.name}${
										suffix === ('jpg' || 'jpeg')
											? '?x-oss-process=image/quality,Q_40'
											: ''
									}`

									console.log(uData)
									this.list.push(uData)
									const backData = {
										name: this.flieName,
										files: this.list,
										index: isNaN(this.index) ? -1 : this.index
									}
									this.$emit('getFile', backData, this.item)
									this.$refs.fileInput.value = ''
								})
								.catch((error) => {
									console.log(error);
									console.log(3333333);
									//上传失败
									this.loading = false
									this.$message.error('上传失败，请重新上传！')
									this.$refs.fileInput.value = ''
								})
							// 或者返回如下：
							// resolve({
							//     fileUrl: `${OSSConfig.uploadHost}/${fileName}`,
							//     fileName: file.name
							// })
						})
					})
					// qiniuToken({})
					// 	.then(res => {
					// 		const token = res.token
					// 		const imgUrl = res.url
					// 		const axiosInstance = axios.create({ withCredentials: false }) //withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
					// 		let data = new FormData()
					// 		data.append('token', token) //七牛需要的token，叫后台给，是七牛账号密码等组成的hash
					// 		data.append('file', file)
					// 		axiosInstance({
					// 			method: 'POST',
					// 			url: 'https://upload-z1.qiniup.com/', //上传地址
					// 			data: data,
					// 			timeout: 30000 //超时时间，因为图片上传有可能需要很久
					// 			// onUploadProgress: (progressEvent)=> {
					// 			//     //imgLoadPercent 是上传进度，可以用来添加进度条
					// 			//     let imgLoadPercent = Math.round(progressEvent.loaded * 100 / progressEvent.total);
					// 			//     console.log(imgLoadPercent)
					// 			// },
					// 		})
					// 			.then(data => {
					// 				this.loading = false
					// 				let uData = {}
					// 				uData.url = imgUrl + '/' + data.data.key
					// 				// if (process.env.NODE_ENV == "development") {
					// 				//   uData.baseUrl = await this.getImgBase64(uData.url);
					// 				// }
					// 				this.list.push(uData)
					// 				const backData = {
					// 					name: this.flieName,
					// 					files: this.list,
					// 					index: isNaN(this.index) ? -1 : this.index
					// 				}
					// 				this.$emit('getFile', backData, this.item)
					// 			})
					// 			.catch(() => {
					// 				//上传失败
					// 				+
					0
					7 // 				this.$message.error('上传失败，请重新上传！')
					// 			})
					// 	})
					// 	.catch(() => {
					// 		this.loading = false
					// 	})
				} else {
					this.$message.error('文件类型不正确,请重新上传！')
				}
			} else {
				this.$message.error('图片大小超过100kb,请重新上传')
			}
		},
		chooseImg() {
			if (!this.loading) {
				this.$refs.fileInput.click()
			}
		},
		prev(index) {
			if (index !== 0) {
				const oldArr = [...this.list]
				this.list[index - 1] = oldArr[index]
				this.list[index] = oldArr[index - 1]
				const backData = {
					name: this.flieName,
					files: this.list
				}
				this.$emit('getFile', backData)
			}
		},
		next(index) {
			if (index !== this.list.length - 1) {
				const oldArr = [...this.list]
				this.list[index + 1] = oldArr[index]
				this.list[index] = oldArr[index + 1]
				const backData = {
					name: this.flieName,
					files: this.list
				}
				this.$emit('getFile', backData)
			}
		},
		preview(index) {
			this.$alert(
				`<img src="${this.list[index].url}" width="100%" alt="">`,
				'图片预览',
				{ dangerouslyUseHTMLString: true, showConfirmButton: false }
			)
		},
		delImg(index) {
			this.list.splice(index, 1)
			this.$refs.fileInput.value = '' //请空input
			const backData = {
				name: this.flieName,
				files: this.list
			}
			this.$emit('getFile', backData)
		},
		defaultImgs(newValue) {
			const list = []
			if (typeof newValue === 'string' && newValue !== '') {
				list.push({ url: newValue })
			} else if (newValue instanceof Array) {
				newValue.forEach(item => {
					if (item) {
						list.push({ url: item })
					}
				})
			}
			this.list = list
		}
	}
}
</script>

<style scoped lang="scss">
.list {
	font-size: 0;
	.item {
		display: inline-block;
		vertical-align: middle;
		font-size: 24px;
		height: 100px;
		width: 100px;
		border-radius: 6px;
		border: 1px dashed #d9d9d9;
		position: relative;
		overflow: hidden;
		margin: 0 12px 12px 0;
		line-height: 100px;
		text-align: center;
		cursor: pointer;
		.previewImg {
			height: 100%;
			width: 100%;
		}
		.el-icon-loading {
			color: #fc501c;
		}
		.imgMask {
			position: absolute;
			left: 0;
			top: 0;
			height: 100%;
			width: 100%;
			background: rgba(0, 0, 0, 0.3);
			opacity: 0;
			transition: opacity 0.5s;
			color: #fff;
			line-height: 1.5;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
		}
		&:hover {
			.imgMask {
				opacity: 1;
			}
		}
		.fileInput {
			display: none;
		}
	}
}
.tc {
	.item {
		margin: 0 auto;
	}
}
</style>
